export default "__VITE_ASSET__3874ecd3__"